module.exports = __webpack_public_path__ + "img/daichao1.40ab85e9.png";